module.exports = [{
      plugin: require('/Users/rumen/Work/Peychev/so-far/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
